import getPlaceData from './getPlaceData'
import buildForm from './buildForm'

function getChildrenData(request) {
  return [...new Array(request.childCount)].map((child, index) => getChildData(request, index + 1))
}

function getChildData(request, index) {
  const age = request.children[`child${index}`]
  return {
    age,
    lapChild: Number(age) === 0,
  }
}

function getTravelers(request) {
  return JSON.stringify({
    adults: Number(request.adultCount || request.adultsCount || 0),
    children: request.childrenData || getChildrenData(request),
  })
}

function buildShopSearchForm(URL, request, target = '_blank') {
  const req = {
    id: 'vp-form',
    fields: Object.assign(
      {
        components: {
          id: 'vacation-components',
          value: JSON.stringify(request.components),
        },
      },
      request.isComponentDeeplink
        ? {
            cartKey: {
              id: 'vacation-cartKey',
              value: request.cartKey,
            },
            pricing: {
              id: 'vacation-pricing',
              value: JSON.stringify(request.pricing),
            },
            isComponentDeeplink: {
              id: 'vacation-component-deeplink',
              value: 'true',
            },
          }
        : {
            travelStartDate: {
              id: 'vacation-ts',
              value: request.departureDate,
            },
            travelEndDate: { id: 'vacation-te', value: request.returnDate },
            travelers: {
              id: 'vacation-travelers',
              value: getTravelers(request),
            },
            origin: {
              id: 'vacation-orig',
              value: JSON.stringify(getPlaceData(request.departureLocation)),
            },
            destination: {
              id: 'vacation-dest',
              value: JSON.stringify(getPlaceData(request.arrivalLocation)),
            },
            pivotComponentKey: {
              id: 'vacation-pivotComponentKey',
              value: request.pivotComponentKey,
            },
            isRecommendedTrip: {
              id: 'vacation-recommended',
              value: JSON.stringify(request.isRecommendedTrip || false),
            },
            ...(request.useFireFlyInventory !== undefined
              ? {
                  useFireFlyInventory: {
                    id: 'vacation-firefly',
                    value: JSON.stringify(request.useFireFlyInventory),
                  },
                }
              : {}),
            containsXSell: {
              id: 'vacation-xsell',
              value: JSON.stringify(request.containsXSell || false),
            },
          }
    ),
  }

  return buildForm(URL, req, target)
}

export default buildShopSearchForm
